import { configureStore } from "@reduxjs/toolkit";
import { isAuthSlice } from "./slices/auth/auth";
import { isClickupSlice } from "./slices/clickup/clickup";
import { isActiveSlice } from "./slices/example/example";
import { isGeneralSlice } from "./slices/general/general";
import { isProjectSlice } from "./slices/project/project";
import { isUiSlice } from "./slices/ui/ui";
import { isAnalitySlice } from "./slices/anality/anality";
import { isSimulationSlice } from "./slices/simulation/simulation";

export const store = configureStore({
	// todas los reducers de los slices
	// exampleName es la forma en la cual se llamaran dentro de los componentes
	reducer: {
		exampleName: isActiveSlice.reducer,
		auth: isAuthSlice.reducer,
		ui: isUiSlice.reducer,
		project: isProjectSlice.reducer,
		general: isGeneralSlice.reducer,
		clickup: isClickupSlice.reducer,
		anality: isAnalitySlice.reducer,
		simulation: isSimulationSlice.reducer,
	},
});
